"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTooltip = exports.TOOLTIP_POSITION = void 0;
var _react = require("react");
var _useToggle = _interopRequireDefault(require("react-use/lib/useToggle"));
var _server = require("b2b-components/utils/server");
var TOOLTIP_POSITION = exports.TOOLTIP_POSITION = /*#__PURE__*/function (TOOLTIP_POSITION) {
  TOOLTIP_POSITION["top"] = "top";
  TOOLTIP_POSITION["bottom"] = "bottom";
  return TOOLTIP_POSITION;
}(TOOLTIP_POSITION || {});
const useTooltip = function () {
  let {
    isPositionFixed = false,
    position = TOOLTIP_POSITION.top
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const body = !_server.isServer ? document.body : undefined;
  const clientHeight = body?.clientHeight || 0;
  const clientWidth = body?.clientWidth || 0;
  const [isTooltipVisible, setTooltipVisible] = (0, _useToggle.default)(false);
  const [tooltipPosition, setTooltipPosition] = (0, _react.useState)({
    top: 0,
    left: 0
  });
  const tooltipAnchorRef = (0, _react.useRef)(null);
  const tooltipRef = (0, _react.useRef)(null);
  const handleMouseEnter = () => {
    setTooltipVisible(true);
  };
  const handleMouseLeave = () => {
    setTooltipVisible(false);
  };
  const updateTooltipPosition = () => {
    const tooltipAnchor = tooltipAnchorRef.current;
    const tooltip = tooltipRef.current;
    const scrollY = !_server.isServer ? window.scrollY : 0;
    if (isTooltipVisible && tooltip && tooltipAnchor) {
      const triangleSpacing = 5;
      const {
        left: togglerLeft,
        top: togglerTop,
        bottom: togglerBottom
      } = tooltipAnchor.getBoundingClientRect();
      const {
        offsetWidth: togglerWidth
      } = tooltipAnchor;
      const {
        offsetHeight: tooltipHeight,
        offsetWidth: tooltipWidth
      } = tooltip;
      const top = togglerTop - tooltipHeight - triangleSpacing;
      const bottom = togglerBottom + triangleSpacing;
      const topPosition = position === TOOLTIP_POSITION.top ? top : bottom;
      setTooltipPosition({
        left: togglerLeft - tooltipWidth / 2 + togglerWidth / 2,
        top: isPositionFixed ? topPosition : topPosition + scrollY
      });
    }
  };
  (0, _react.useEffect)(() => {
    updateTooltipPosition();
  }, [clientHeight, clientWidth]);
  return {
    isTooltipVisible,
    onMouseLeave: handleMouseLeave,
    onMouseEnter: handleMouseEnter,
    tooltipAnchorRef,
    tooltipPosition,
    tooltipRef,
    updateTooltipPosition
  };
};
exports.useTooltip = useTooltip;
//# sourceMappingURL=useTooltip.js.map